import { PlatformService } from '../../platform/platform.service';
import { WorkflowOfflineAndroidDao } from './workflow-offline-android.dao';
import { WorkflowOfflineWebDao } from './workflow-offline-web.dao';
import { WorkflowOfflineDao } from './workflow-offline.dao';

const WorkflowOfflineDaoFactory = (platformService: PlatformService) => platformService.isAndroidApp() ? 
    new WorkflowOfflineAndroidDao() : new WorkflowOfflineWebDao();

export const WorkflowOfflineDaoProvider = { 
    provide: WorkflowOfflineDao,
    useFactory: WorkflowOfflineDaoFactory,
    deps: [PlatformService]
};